// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-media-div {
  font-size: 2em;
}

.icon-button i {
  color: white;
}
.icon-button {
  margin-bottom: 10px;
}

.icon-button i {
  border-radius: 2.6rem;
  cursor: pointer;
  display: inline-block;
  font-size: 1.3rem;
  height: 2.6rem;
  line-height: 2.6rem;
  margin: 0 5px;
  position: relative;
  text-align: center;
  -webkit-user-select: none;
  user-select: none;
  width: 2.6rem;
  margin-bottom: 10px;
}

.linkedin i {
  background-color: #0e76a8;
  transition: all 0.2s ease-in-out;
}

.linkedin i:hover {
  color: rgba(255, 255, 255, 1);
  box-shadow: 0 5px 15px #0e76a8;
}

.github i {
  background-color: #333;
  transition: all 0.2s ease-in-out;
}

.github i:hover {
  color: rgba(255, 255, 255, 1);
  box-shadow: 0 5px 15px #333;
}

.gitlab i {
  background-color: #ffcc52;
  transition: all 0.2s ease-in-out;
}

.gitlab i:hover {
  color: rgba(255, 255, 255, 1);
  box-shadow: 0 5px 15px #333;
}

.google i {
  background-color: #ea4335;
  transition: all 0.2s ease-in-out;
}

.google i:hover {
  color: rgba(255, 255, 255, 1);
  box-shadow: 0 5px 15px #ea4335;
}

.twitter i {
  background-color: #1da1f2;
  transition: all 0.2s ease-in-out;
}

.twitter i:hover {
  color: rgba(255, 255, 255, 1);
  box-shadow: 0 5px 15px #1da1f2;
}

.instagram i {
  background-color: #e4405f;
  transition: all 0.2s ease-in-out;
}

.instagram i:hover {
  color: rgba(255, 255, 255, 1);
  box-shadow: 0 5px 15px #e4405f;
}

/* Media Query */
@media (max-width: 768px) {
  .social-media-div {
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/socialMedia/SocialMedia.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".social-media-div {\n  font-size: 2em;\n}\n\n.icon-button i {\n  color: white;\n}\n.icon-button {\n  margin-bottom: 10px;\n}\n\n.icon-button i {\n  border-radius: 2.6rem;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 1.3rem;\n  height: 2.6rem;\n  line-height: 2.6rem;\n  margin: 0 5px;\n  position: relative;\n  text-align: center;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 2.6rem;\n  margin-bottom: 10px;\n}\n\n.linkedin i {\n  background-color: #0e76a8;\n  transition: all 0.2s ease-in-out;\n}\n\n.linkedin i:hover {\n  color: rgba(255, 255, 255, 1);\n  box-shadow: 0 5px 15px #0e76a8;\n}\n\n.github i {\n  background-color: #333;\n  transition: all 0.2s ease-in-out;\n}\n\n.github i:hover {\n  color: rgba(255, 255, 255, 1);\n  box-shadow: 0 5px 15px #333;\n}\n\n.gitlab i {\n  background-color: #ffcc52;\n  transition: all 0.2s ease-in-out;\n}\n\n.gitlab i:hover {\n  color: rgba(255, 255, 255, 1);\n  box-shadow: 0 5px 15px #333;\n}\n\n.google i {\n  background-color: #ea4335;\n  transition: all 0.2s ease-in-out;\n}\n\n.google i:hover {\n  color: rgba(255, 255, 255, 1);\n  box-shadow: 0 5px 15px #ea4335;\n}\n\n.twitter i {\n  background-color: #1da1f2;\n  transition: all 0.2s ease-in-out;\n}\n\n.twitter i:hover {\n  color: rgba(255, 255, 255, 1);\n  box-shadow: 0 5px 15px #1da1f2;\n}\n\n.instagram i {\n  background-color: #e4405f;\n  transition: all 0.2s ease-in-out;\n}\n\n.instagram i:hover {\n  color: rgba(255, 255, 255, 1);\n  box-shadow: 0 5px 15px #e4405f;\n}\n\n/* Media Query */\n@media (max-width: 768px) {\n  .social-media-div {\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
